jQuery(document).ready(function ($) {

    var Theme5 = (function () {

        var siteSliders = function () {

            var partnersHome = $("#slider-partners");

            partnersHome.owlCarousel({
                items: 5,
                itemsDesktop: [1200, 5],
                itemsDesktopSmall: [992, 4],
                itemsMobile: [767, 1],
                pagination: false,
                navigation: true
            });

            var resultsSlidshow = $(".results-slidshow");

            resultsSlidshow.owlCarousel({
                items: 1,
                pagination: false,
                navigation: true,
                responsiveClass: true,
                loop: true,
                singleItem: true,
                margin: 0
            });

            enquire.register("screen and (max-width: 767px)", {

                match: function () {

                    var practiceAreaSlidshow = $(".grid-pa");

                    practiceAreaSlidshow.owlCarousel({
                        items: 1,
                        pagination: false,
                        navigation: true,
                        margin: 0,
                        responsiveClass: true,
                        loop: true,
                        singleItem: true
                    });

                }

            });

            var testimonials = $("#testimonial-slider");

            testimonials.owlCarousel({
                items: 1,
                pagination: true,
                navigation: false,
                responsiveClass: true,
                loop: true,
                singleItem: true
            });

            var attorneys = $("#slider-attorneys");

            attorneys.owlCarousel({
                items: 6,
                itemsDesktop: [1200, 5],
                itemsDesktopSmall: [992, 3],
                itemsMobile: [767, 1],
                pagination: false,
                navigation: true
            });

            var results = $("#slider-results");

            results.owlCarousel({
                items: 6,
                itemsDesktop: [1200, 6],
                itemsDesktopSmall: [992, 3],
                itemsMobile: [767, 1],
                pagination: false,
                navigation: true
            });


            enquire.register("screen and (max-width: 767px)", {
                match: function () {

                    // Top Logos On Slider
                    $(".location-logos .grid-logos").slick({
                        slidesToShow: 1,
                        infinite: true,
                        autoplay: false,
                        slidesToScroll: 1,
                        initialSlide: 0,
                        speed: 300,
                        prevArrow: '<span class="fa fa-chevron-left"></span>',
                        nextArrow: '<span class="fa fa-chevron-right"></span>',
                        appendArrows: '.slick-nav-logos-sidebar',
                        dots: false,
                        centerMode: true,
                        variableWith: false
                    });

                },
                unmatch: function () {

                }
            });

        };

        var credentialsWidget = function () {

            $('.widget-credentials').on('click', '.panel-heading', function () {

                $link = $('.widget-credentials .panel-heading');

                if ($(this).hasClass('open')) {
                    $(this).removeClass('open');
                } else {
                    $link.removeClass('open');
                    $(this).addClass('open');
                }

            });

        };

        var sameHeight = function () {

            enquire.register("screen and (min-width: 1200px)", {

                match: function () {

                    $('.footer-contacts .sameHeight').matchHeight();

                    $('#attorneys.single .sameHeight').matchHeight();

                }
            });

            $('.types-subsection #myCarousel .sameHeight').matchHeight();
            $('.squares-grid .sameHeight').matchHeight();

        };

        var faqs = function () {
            $('.qa-faqs h3 a').on('click', function (event) {
                event.preventDefault();

                $('.qa-faqs h3 a').removeClass('active');
                $('.qa-faqs h3').removeClass('open');

                $(this).stop().toggleClass('active');
                $(this).parent().toggleClass('open');

            });
        };

        var tableOfContents = function () {

            var ToC = '';

            var newLine, el, title, link;

            $(".toc-heading").each(function () {

                el = $(this);
                title = el.text();
                link = "#" + el.attr("id");

                newLine =
                    "<li>" +
                    "<a class='toc-link' href='" + link + "'>" +
                    title +
                    "</a>" +
                    "</li>";

                ToC += newLine;

            });

            //console.log(ToC);

            //ToC += "</ul></div></div></div>";

            $(".contents-table ul").prepend(ToC);

            $('.contents-table ul').smoothScroll();

            $(".toc-link:empty").each(function () {
                $(this).parent().css({
                    display: 'none'
                });
            });

        };

        var googleFooterMap = function () {

            enquire.register("screen and (min-width: 992px)", {

                match: function () {

                    var map;

                    function initialize() {

                        var newlat = parseFloat($('#headingLocation1').find('a').data('lat'));
                        var newlng = parseFloat($('#headingLocation1').find('a').data('lng'));

                        map = new google.maps.Map(document.getElementById('footer-map'), {
                            zoom: 14,
                            draggable: false,
                            center: {lat: newlat, lng: newlng},
                            disableDefaultUI: true,
                            styles: [
                                {
                                    "featureType": "administrative",
                                    "elementType": "labels.text.fill",
                                    "stylers": [
                                        {
                                            "color": "#444444"
                                        }
                                    ]
                                },
                                {
                                    "featureType": "landscape",
                                    "elementType": "all",
                                    "stylers": [
                                        {
                                            "color": "#f2f2f2"
                                        }
                                    ]
                                },
                                {
                                    "featureType": "poi",
                                    "elementType": "all",
                                    "stylers": [
                                        {
                                            "visibility": "off"
                                        }
                                    ]
                                },
                                {
                                    "featureType": "road",
                                    "elementType": "all",
                                    "stylers": [
                                        {
                                            "saturation": -100
                                        },
                                        {
                                            "lightness": 45
                                        }
                                    ]
                                },
                                {
                                    "featureType": "road.highway",
                                    "elementType": "all",
                                    "stylers": [
                                        {
                                            "visibility": "simplified"
                                        }
                                    ]
                                },
                                {
                                    "featureType": "road.arterial",
                                    "elementType": "labels.icon",
                                    "stylers": [
                                        {
                                            "visibility": "off"
                                        }
                                    ]
                                },
                                {
                                    "featureType": "transit",
                                    "elementType": "all",
                                    "stylers": [
                                        {
                                            "visibility": "off"
                                        }
                                    ]
                                },
                                {
                                    "featureType": "water",
                                    "elementType": "all",
                                    "stylers": [
                                        {
                                            "color": "#aad2e3"
                                        },
                                        {
                                            "visibility": "on"
                                        }
                                    ]
                                }
                            ]
                        });

                        var image = '/wp-content/themes/cw-theme-five/assets/images/icons/marker.png';

                        marker = new google.maps.Marker(
                            {
                                map: map,
                                position: {lat: newlat, lng: newlng},
                                icon: image
                            }
                        );

                    }

                    google.maps.event.addDomListener(window, 'load', initialize);
                    $('#location-accordion').on('click', '.panel-heading a', function () {

                        var newzoom = 14;
                        map.setZoom(newzoom);

                        var newlat = parseFloat($(this).data('lat'));
                        var newlng = parseFloat($(this).data('lng'));
                        map.setCenter({lat: newlat, lng: newlng});

                        console.log(newlat);
                        console.log(newlng);

                        /*
                        enquire.register("screen and (min-width: 768px)", {
                            match: function () {
                                map.panBy(170, -50);
                            }
                        });

                        enquire.register("screen and (max-width: 767px)", {
                            match: function () {
                                map.panBy(0, -50);
                            }
                        });
                        */

                        var image = '/wp-content/themes/cw-theme-five/assets/images/icons/marker.png';

                        if (marker && marker.setMap) {
                            marker.setMap(null);
                        }

                        marker = new google.maps.Marker(
                            {
                                map: map,
                                position: {lat: newlat, lng: newlng},
                                icon: image
                            }
                        );

                        marker.setMap(map);

                    });

                    $('.footer-contacts .sameHeight').matchHeight();

                }

            });

        };

        var googleFooterMapMobile = function () {

            enquire.register("screen and (max-width: 991px)", {
                match: function () {

                    var map;

                    function initialize() {

                        var newlat = parseFloat($('#headingLocation1').find('a').data('lat'));
                        var newlng = parseFloat($('#headingLocation1').find('a').data('lng'));

                        map = new google.maps.Map(document.getElementById('footer-map1'), {
                            zoom: 14,
                            draggable: false,
                            center: {lat: newlat, lng: newlng},
                            disableDefaultUI: true,
                            styles: [
                                {
                                    "featureType": "administrative",
                                    "elementType": "labels.text.fill",
                                    "stylers": [
                                        {
                                            "color": "#444444"
                                        }
                                    ]
                                },
                                {
                                    "featureType": "landscape",
                                    "elementType": "all",
                                    "stylers": [
                                        {
                                            "color": "#f2f2f2"
                                        }
                                    ]
                                },
                                {
                                    "featureType": "poi",
                                    "elementType": "all",
                                    "stylers": [
                                        {
                                            "visibility": "off"
                                        }
                                    ]
                                },
                                {
                                    "featureType": "road",
                                    "elementType": "all",
                                    "stylers": [
                                        {
                                            "saturation": -100
                                        },
                                        {
                                            "lightness": 45
                                        }
                                    ]
                                },
                                {
                                    "featureType": "road.highway",
                                    "elementType": "all",
                                    "stylers": [
                                        {
                                            "visibility": "simplified"
                                        }
                                    ]
                                },
                                {
                                    "featureType": "road.arterial",
                                    "elementType": "labels.icon",
                                    "stylers": [
                                        {
                                            "visibility": "off"
                                        }
                                    ]
                                },
                                {
                                    "featureType": "transit",
                                    "elementType": "all",
                                    "stylers": [
                                        {
                                            "visibility": "off"
                                        }
                                    ]
                                },
                                {
                                    "featureType": "water",
                                    "elementType": "all",
                                    "stylers": [
                                        {
                                            "color": "#aad2e3"
                                        },
                                        {
                                            "visibility": "on"
                                        }
                                    ]
                                }
                            ]
                        });

                        var image = '/wp-content/themes/cw-theme-five/assets/images/icons/marker.png';

                        marker = new google.maps.Marker(
                            {
                                map: map,
                                position: {lat: newlat, lng: newlng},
                                icon: image
                            }
                        );

                    }

                    google.maps.event.addDomListener(window, 'load', initialize());

                    $('#location-accordion').on('click', '.panel-heading a', function () {

                        var map_mobile;
                        var map_mobile_lat = parseFloat($(this).data('lat'));
                        var map_mobile_lng = parseFloat($(this).data('lng'));
                        var loc_index = parseFloat($(this).parent().parent().data('number'));

                        function initialize_mobile(index, map_mobile_lat, map_mobile_lng) {

                            map_mobile = new google.maps.Map(document.getElementById('footer-map' + index), {
                                zoom: 14,
                                draggable: false,
                                center: {lat: map_mobile_lat, lng: map_mobile_lng},
                                disableDefaultUI: true,
                                styles: [
                                    {
                                        "featureType": "administrative",
                                        "elementType": "labels.text.fill",
                                        "stylers": [
                                            {
                                                "color": "#444444"
                                            }
                                        ]
                                    },
                                    {
                                        "featureType": "landscape",
                                        "elementType": "all",
                                        "stylers": [
                                            {
                                                "color": "#f2f2f2"
                                            }
                                        ]
                                    },
                                    {
                                        "featureType": "poi",
                                        "elementType": "all",
                                        "stylers": [
                                            {
                                                "visibility": "off"
                                            }
                                        ]
                                    },
                                    {
                                        "featureType": "road",
                                        "elementType": "all",
                                        "stylers": [
                                            {
                                                "saturation": -100
                                            },
                                            {
                                                "lightness": 45
                                            }
                                        ]
                                    },
                                    {
                                        "featureType": "road.highway",
                                        "elementType": "all",
                                        "stylers": [
                                            {
                                                "visibility": "simplified"
                                            }
                                        ]
                                    },
                                    {
                                        "featureType": "road.arterial",
                                        "elementType": "labels.icon",
                                        "stylers": [
                                            {
                                                "visibility": "off"
                                            }
                                        ]
                                    },
                                    {
                                        "featureType": "transit",
                                        "elementType": "all",
                                        "stylers": [
                                            {
                                                "visibility": "off"
                                            }
                                        ]
                                    },
                                    {
                                        "featureType": "water",
                                        "elementType": "all",
                                        "stylers": [
                                            {
                                                "color": "#aad2e3"
                                            },
                                            {
                                                "visibility": "on"
                                            }
                                        ]
                                    }
                                ]
                            });

                            var image = '/wp-content/themes/cw-theme-five/assets/images/icons/marker.png';

                            if (marker && marker.setMap) {
                                marker.setMap(null);
                            }

                            marker = new google.maps.Marker(
                                {
                                    map: map_mobile,
                                    position: {lat: map_mobile_lat, lng: map_mobile_lng},
                                    icon: image
                                }
                            );

                            marker.setMap(map_mobile);

                        }

                        google.maps.event.addDomListener(window, 'load', initialize_mobile(loc_index, map_mobile_lat, map_mobile_lng));

                    });


                }

            });
        };

        var locationDetailsMap = function () {

            if ($('.page-template-location #map_temp').length > 0) {

                var map_temp;
                var map_temp_lat = parseFloat($('#map_temp').data('temp-lat'));
                var map_temp_lng = parseFloat($('#map_temp').data('temp-lng'));

                console.log(map_temp_lat);
                console.log(map_temp_lng);

                function initialize_temp() {

                    map_temp = new google.maps.Map(document.getElementById('map_temp'), {
                        zoom: 14,
                        draggable: false,
                        center: {lat: map_temp_lat, lng: map_temp_lng},
                        disableDefaultUI: true,
                        styles: [
                            {
                                "featureType": "administrative",
                                "elementType": "labels.text.fill",
                                "stylers": [
                                    {
                                        "color": "#444444"
                                    }
                                ]
                            },
                            {
                                "featureType": "landscape",
                                "elementType": "all",
                                "stylers": [
                                    {
                                        "color": "#f2f2f2"
                                    }
                                ]
                            },
                            {
                                "featureType": "poi",
                                "elementType": "all",
                                "stylers": [
                                    {
                                        "visibility": "off"
                                    }
                                ]
                            },
                            {
                                "featureType": "road",
                                "elementType": "all",
                                "stylers": [
                                    {
                                        "saturation": -100
                                    },
                                    {
                                        "lightness": 45
                                    }
                                ]
                            },
                            {
                                "featureType": "road.highway",
                                "elementType": "all",
                                "stylers": [
                                    {
                                        "visibility": "simplified"
                                    }
                                ]
                            },
                            {
                                "featureType": "road.arterial",
                                "elementType": "labels.icon",
                                "stylers": [
                                    {
                                        "visibility": "off"
                                    }
                                ]
                            },
                            {
                                "featureType": "transit",
                                "elementType": "all",
                                "stylers": [
                                    {
                                        "visibility": "off"
                                    }
                                ]
                            },
                            {
                                "featureType": "water",
                                "elementType": "all",
                                "stylers": [
                                    {
                                        "color": "#aad2e3"
                                    },
                                    {
                                        "visibility": "on"
                                    }
                                ]
                            }
                        ]
                    });

                    map_temp.panBy(0, -50);

                    var image = '/wp-content/themes/cw-theme-five/assets/images/marker.png';

                    var marker_temp = new google.maps.Marker(
                        {
                            map: map_temp,
                            position: {lat: map_temp_lat, lng: map_temp_lng},
                            icon: image
                        }
                    );

                }

                google.maps.event.addDomListener(window, 'load', initialize_temp);

            }

        };

        var contactDetailsMap = function () {

            if ($('.grid-locations').length > 0) {

                $(window).load(function () {

                    $(".grid-locations .item").each(function (index, element) {

                        var map_contact;
                        var map_contact_lat = parseFloat($(this).data('contact-lat'));
                        var map_contact_lng = parseFloat($(this).data('contact-lng'));

                        var index = ++index;

                        console.log(map_contact_lat);
                        console.log(map_contact_lng);

                        function initialize_contact(index, map_contact_lat, map_contact_lng) {

                            map_contact = new google.maps.Map(document.getElementById('contact-map' + index), {
                                zoom: 14,
                                draggable: false,
                                center: {lat: map_contact_lat, lng: map_contact_lng},
                                disableDefaultUI: true
                            });

                        }

                        google.maps.event.addDomListener(window, 'load', initialize_contact(index, map_contact_lat, map_contact_lng));

                    });


                });


            }


        };

        var mobileNav = function () {

            enquire.register("screen and (max-width: 767px)", {
                match: function () {

                    $('.menu-navigation ul.main-nav > li.menu-item-has-children > a').on('click', function (e) {
                        e.preventDefault();
                        $(this).next().slideToggle().toggleClass('open');
                    });

                    $('.menu-navigation ul.main-nav > li.menu-item-has-children > ul.sub-menu > li.menu-item-has-children > a').on('click', function (e) {
                        e.preventDefault();
                        $(this).next().slideToggle().toggleClass('open');
                    });

                },
                unmatch: function () {

                }
            });

            $('.nav-opener').on('click', function () {
                var overlay = document.querySelector("body");
                overlay.classList.toggle('hide-overlay');
            });

            enquire.register("screen and (max-width: 767px)", {
                match: function () {

                    $('#location-accordion .panel-heading').on('click', function () {
                        $(this).toggleClass('open');
                    });

                }
            });

        };

        var videoOutput = function () {

            if ($('.cw_video_gallery').length > 0) {

                $videoLinks = $('.cw_video_gallery .cw_video_item .cw_video_open_popup');

                $videoLinks.each(function (index, element) {
                    $link = $(this).attr('href');
                    $text = $link.replace("?rel=&amp;", "?rel=0&");
                    $(this).attr('href', $text);
                });

            }

        };

        var imageMap = function () {
            $('#location-accordion').on('click', '.panel-heading', function (e) {
                $bg = $(this).data('map');
                $('#footer-map-wrapper').find('#footer-map').css('background', 'url("' + $bg + '") no-repeat scroll center center transparent');
            });
        }

        var footerAccordion = function () {

            $('#location-accordion .panel-heading').on('click', function () {

                $link = $('#location-accordion .panel-heading');

                if ($(this).hasClass('open')) {

                    $(this).removeClass('open');

                    console.log('test2');

                } else {

                    $link.removeClass('open');

                    $(this).addClass('open');

                    console.log('test2');

                }

            });

        };

        var videoPopupInit = function () {

            $('.video-content .icon-play').on('click', function () {

                // Play video on play
                $("#bannerVideo").on('shown.bs.modal', function (e) {
                    var $this2 = $(this);
                    var $frame2 = $this2.find('.modal-content #video_play iframe');
                    $frame2.attr("src", $frame2.attr("data-src"));
                    $frame2[0].src += "1";
                });

            });

            //Stop video on play
            $(".modal").on('hidden.bs.modal', function (e) {
                var $this = $(this);

                if ($('#video_play').length > 0) {
                    var $frame = $this.find('.modal-content #video_play iframe');
                    $frame.attr("src", $frame.attr("src").replace("autoplay=1", "autoplay="));
                }

            });

        };

        var videoBannerInit = function () {

            setTimeout(function () {
                if ($('#video-background').length > 0) {
                    document.getElementById('video-background').play();
                }
            }, 1777);

        };

        var mainJS = function () {

            //Skip Link
            var skipLink = function () {
                $(".skiplink").focusin(function () {
                    $(this).css("position", "static");
                });

                $(".skiplink").focusout(function () {
                    $(this).css("position", "absolute");
                });
            }

            // ===== Scroll to Top ==== 
            enquire.register("screen and (max-width: 767px)", {

                match: function () {

                    $(window).scroll(function() {
                        if ($(this).scrollTop() >= 300) {        // If page is scrolled more than 50px
                            $('#return-to-top').fadeIn(200);    // Fade in the arrow
                        } else {
                            $('#return-to-top').fadeOut(200);   // Else fade out the arrow
                        }
                    });
                }
            });
            

            /* return to top button */
            $('#return-to-top').click(function() {    
                $('body,html').animate({
                    scrollTop : 0                       
                }, 500);
            });

        };

        return {

            init: function () {
                videoBannerInit();
                siteSliders();
                credentialsWidget();
                sameHeight();
                faqs();
                tableOfContents();
                footerAccordion();
                mobileNav();
                videoOutput();
                mainJS();

                //locationDetailsMap();
                //googleFooterMap();
                //googleFooterMapMobile();
                //contactDetailsMap();

                imageMap();

                videoPopupInit();
            }

        }

    })();

    Theme5.init();

});
